import { AiReviewStatus } from '@treadinc/horizon-api-spec';
import { noop, startCase } from 'lodash-es';
import { useCallback } from 'react';

import { InfiniteQuery, InfiniteQueryOption } from './constants';

const data: InfiniteQueryOption[] = Object.values(AiReviewStatus).map((status) => ({
  label: startCase(status),
  value: `${status}`,
}));

export default function useAiReviewStatusInfiniteQuery(): InfiniteQuery {
  const noopFn = useCallback(() => {
    return noop;
  }, []);

  return {
    clear: noopFn,
    data,
    fetch: noopFn,
    fetchMore: undefined,
    isDummyQuery: true,
  };
}
